module.exports = __webpack_public_path__ + "726b76e323b6508c00bb54a122582172.png";